import React from 'react';
import {
  Switch,
  Route,
  useRouteMatch,
} from 'react-router-dom';

import {
  PageSetting,
} from '../pages/setting';

const RouteViewSlots = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path}>
        <PageSetting />
      </Route>
    </Switch>
  );
};

export default RouteViewSlots;
